import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";

type CustomChipProps = {
  chip: string;
  isLocked: boolean;
  onRemove: (chip: string) => void;
};

export default function CustomChip({
  chip,
  isLocked,
  onRemove,
}: CustomChipProps) {
  const confirmRemove = () => {
    confirmDialog({
      message: `Czy na pewno chcesz usunąć "${chip}"?`,
      header: "Potwierdź usunięcie",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Usuwać",
      rejectLabel: "Anulować",
      accept: () => onRemove(chip),
      acceptClassName: "p-button-danger",
      className: "custom-confirm-dialog",
    });
  };

  return (
    <>
      <span title={isLocked ? "Used in future delivery" : ""}>
        {chip.toUpperCase()}
      </span>
      {!isLocked && (
        <Button
          icon="pi pi-times"
          rounded
          outlined
          severity="secondary"
          aria-label="Delete"
          className="custom-chip-delete"
          onClick={(e) => {
            e.preventDefault();
            confirmRemove();
          }}
        />
      )}
    </>
  );
}
